import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const USALandingOptions: LandingPageConfigOptions = {
  countryCode: "us",
  showsUSTerm: true,
};
